import { Divider } from "@mui/material";
import { CreateCarUserTokenEntity } from "../../../../../entities/ServicesEntities/UserEntities/CreateCarUserTokenEntity";
import { useState, forwardRef, useImperativeHandle } from "react";
import { useSelector } from "react-redux";
import { ListItem } from "../../../../../entities/UIEntities/ListItem";
import {
  ADD_ALLOCATIONS_FORM_STEPS,
  ADD_PARKER_ALLOCATION_STEPS,
  INPUTS_PROPS,
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import { handleDeleteOccupiedToken } from "../../../../../utils/MenuUtils";
import { isRequired } from "../../../../../utils/FormUtils";
import {
  showErrorMessage,
  showUpdateSuccessMessage,
} from "../../../../../utils/MessagesUtils";
import SelectInput from "../../../Inputs/CustomInputs/SelectInput";
import classes from "../WizardForm.module.css";
import AllocationCard from "../../../Cards/AllocationCard/AllocationCard";
import * as carUserTokenActionsService from "../../../../../services/ActionsService/CarUserTokenActionsService";
import AddSingleTokenAllocation from "./AddSingleTokenAllocation";
import SearchAutocompleteInput from "../../../Inputs/CustomInputs/SearchAutocompleteInput";
import AddSingleTokenParkerAllocation from "./AddSingleTokenParkerAllocation";
import ParkerAllocationCard from "../../../Cards/ParkerAllocationCard/ParkerAllocationCard";
import { getSiteIconName } from "../../../../../utils/CommonUtils";
import { createGuid } from "../../../../../utils/CommonUtils";

const AssignParkerAllocationStep = forwardRef((props, ref) => {
  const [errors, setErrors] = useState({});

  // allocation add
  //const showAddNewUserButton = useSelector((state) => state.common.showAddNewUserButton);
  const showAdditionalParkingAllocationButton = useSelector((state) => state.common.showAdditionalParkingAllocationButton);

  // handles when fob is not supported - hide assignedParkers list (cause assignedParkers.length > 1 - parkers added on select)
  const showAssigneFobOptions = useSelector((state) => state.common.showAssigneFobOptions); 
  const showExsistingParkingAllocation = useSelector((state) => state.common.showExsistingParkingAllocation);

  // from token component
  const [hasStepErrors, setHasStepErrors] = useState(false);
  const [showSummaryStep, setShowSummaryStep] = useState(props?.isEditMode);
  const [occupiedTokens, setOccupiedTokens] = useState(
    props?.isEditMode ? props?.carUserTokens : []
  );

  let selectedSite = props.selectedSite;

    // added
    //const AddSingleTokenWithFobRef = useRef();

    // added
    useImperativeHandle(ref, () => ({
      //AddSingleTokenWithFobRef,
      occupiedTokens,
      setOccupiedTokens
    }));

  const handleAssignTokenToFob = (token, skipFob = false) => {
    let occupiedTokenCopy = [...occupiedTokens];
    const assignedToken = {
      fob: props.fob === "" || skipFob ? null : props.fob,
      occupiedToken: token,
      tokenId: token?.id, 
    }; // fob: props.fob

    // validates that since selected new parker allocation, and there is already assigned parker
    // all relevant carUserTokens (for every added user)
    // will be associated to only one token 
    if (props.assignedParkerAllocations?.length === 0 || props.isFobSkipped) {
      occupiedTokenCopy.push(assignedToken);
      setOccupiedTokens(occupiedTokenCopy);
    }

    // insert carUserToken
    occupiedTokenCopy.push(assignedToken);
    setOccupiedTokens(occupiedTokenCopy);

    // allocation add -- inserts the carUserToken to the assignedParker - for ui
    //let assignedParkerAllocation = {...props.selectedParker};
    let addedAssignedParkerAllocation = occupiedTokenCopy.map((token) => {
    let carToken = new CreateCarUserTokenEntity(); // create carUserToken obj
    

      // populates the carUserToken obj
      const obj = {
        tokenId: token?.tokenId, 
        token: token?.occupiedToken,
        fob: props.fob === "" || skipFob ? null : props.fob, 
        userId: props?.userData?.utronUser?.id, //selectedParkerCopy.utronUser.id
        uuid: createGuid() // guid to identify for delete action
      };
      return { ...carToken, ...obj };
    });


    //update form
    props.handleChange({
      [INPUTS_PROPS.TOKENS]: occupiedTokenCopy.map(
        (token) => token?.occupiedToken
      ),
      // [INPUTS_PROPS.CAR_USER_TOKEN]: [...props.carUserTokens, occupiedTokenCopy.map((token) => {
      //   let carToken = new CreateCarUserTokenEntity();
      //   const obj = {
      //     tokenId: token?.tokenId,
      //     token: token?.occupiedToken,
      //     fob: props.fob === "" ? null : props.fob, 
      //     userId: props?.userData?.utronUser?.id, //selectedParkerCopy.utronUser.id 
      //     uuid: commonGuid
      //   };
      //   return { ...carToken, ...obj };
      // })[0]],
      [INPUTS_PROPS.CAR_USER_TOKEN]: [...props.carUserTokens, addedAssignedParkerAllocation[addedAssignedParkerAllocation?.length - 1]],
      //allocation Add - add selectedParker to assignedParkers, 
      ["assignedParkerAllocations"] : [...props.assignedParkerAllocations, addedAssignedParkerAllocation[addedAssignedParkerAllocation?.length - 1]],
      ["showTemporaryTokenPreview"] : false
    });

    setShowSummaryStep(true);
  };

  const handleClearAllTokens = () => {
    setOccupiedTokens([]);
  };

  const handleDeleteCreatedAllocation = (allocationUuid) => {
    // find the uuid in both arrays
    let assignedIndexToDelete = props?.assignedParkerAllocations?.findIndex(assign => assign.uuid === allocationUuid);
    let cutIndexToDelete = props?.carUserTokens?.findIndex(cut => cut.uuid === allocationUuid);

    // delete from ui (assignedParkerAllocations)
    let assignedParkerAllocationsCopy = [...props?.assignedParkerAllocations];
    assignedParkerAllocationsCopy.splice(assignedIndexToDelete, 1);

    // delete from data (carUserTokens)
    let carUserTokensCopy = [...props?.carUserTokens];
    carUserTokensCopy.splice(cutIndexToDelete, 1);

    // when tokens list empty remove the save changes button
    if (carUserTokensCopy.length === 0) {
      props.setIsShowSaveChanges(false);
    }

    // update on formData
    props.handleChange({
      ["assignedParkerAllocations"] : assignedParkerAllocationsCopy,
      ["carUserTokens"] : carUserTokensCopy
    }); 
  };

  const handleDeleteAssignedParker = (id) => {
    // splice both in assignedParkers and carUserTokens
    let indexToDelete = props.assignedParkers?.findIndex(parker => parker.utronUser.id === id);
    let assignedParkersCopy = [...props.assignedParkers];
    let carUserTokensCopy = [...props.carUserTokens.flat()];
    assignedParkersCopy.splice(indexToDelete, 1);

    //indexToDelete = props.carUserTokens.flat().findIndex(cut => cut.userId === id);
    carUserTokensCopy.splice(indexToDelete, 1);

    if (assignedParkersCopy?.length === 0) {
      store.dispatch(commonActions.setShowAddNewUserButton(false));
      store.dispatch(commonActions.setShowFobScannerInput(false));
      
      // clear all data
      handleClearAllTokens();
      props.handleChange({
        ["assignedParkers"] : [],
        ["carUserTokens"] : [],
        ["tokens"] : [],
        ["selectedParker"] : null,
        ["foundedExistingParker"] : null,
        ["fob"] : ""
      });
    }
    else { // update data
      props.handleChange({
        ["assignedParkers"] : assignedParkersCopy,
        ["carUserTokens"] : carUserTokensCopy
      });
    }
  };

  const handleDeleteTokenByIndex = (index) => {
    // added
    if (props.isFobSkipped) {
      props.handleChange({ ["carUserTokens"]: [] });
      store.dispatch(commonActions.setAssigneOption(null));
    }
    if (index > -1) {
      const token = occupiedTokens[index].occupiedToken;
      const userTokens = props.carUserTokens.map(
        (token) => token.occupiedToken
      );
      const userTokensIds = userTokens?.map((ot) => ot?.id);
      if (props.isEditMode && userTokensIds.includes(token?.id)) {
        const exsistOccupiedToken = occupiedTokens[
          index
        ].occupiedToken.carUserTokens?.find(
          (cut) => cut.userId === props?.userData?.id
        );
        if (exsistOccupiedToken) {
          handleDeleteOccupiedToken(
            props.userData,
            token?.displayValue,
            deleteCarUsertokenFromServer.bind(
              this,
              exsistOccupiedToken?.id,
              index
            )
          );
        }
      } else {
        deleteCarUsertokenFromView(index);
        if (props.fromGmt === undefined) {
          props.setIsShowSaveChanges(false);
        }
      }
    }
  };
  
  const deleteCarUsertokenFromView = (index) => {
    let occupiedTokenCopy = [...occupiedTokens];
    occupiedTokenCopy.splice(index, 1);
    setOccupiedTokens(occupiedTokenCopy);
  };

  const deleteCarUsertokenFromServer = (carUserTokenId, index) => {
    carUserTokenActionsService
      .deleteCarUserToken(carUserTokenId)
      .then((response) => {
        if (response.data.isSuccess) {
          showUpdateSuccessMessage();
          deleteCarUsertokenFromView(index);
        } else {
          showErrorMessage(response.data?.error);
        }
      });
  };

  const setShowStepError = (boolean) => {
    setHasStepErrors(boolean);
  };

  const handleChange = (event) => {
    if (event[INPUTS_PROPS.FOB]) {
      setErrors({
        ...errors,
        [INPUTS_PROPS.FOB]: isRequired(event[INPUTS_PROPS.FOB]),
      });
    }
    props.handleChange(event);
  };

  const handleError = (error) => {
    setErrors((prevState) => ({
      ...prevState,
      ...error,
    }));
  };

  // if (props.currentStep !== ADD_ALLOCATIONS_FORM_STEPS.SEARCH_PARKER) {
  //   return null;
  // }

  // if (props.currentStep !== ADD_PARKER_ALLOCATION_STEPS.ADD_TOKENS) {
  //   return null;
  // }

  // const handleAddNewUser = () => {
  //   store.dispatch(commonActions.setShowAddNewUserButton(false)); // allocation add

  //   // sets selectedParker to null to prepare for the next selection, clears fob input value
  //   props.handleChange({ ["selectedParker"]: null, ["fob"] : "" });
  // };

  const handleAdditionalParkingAllocation = () => {
      store.dispatch(commonActions.setShowAdditionalParkingAllocationButton(false));

      // show only on first time and once userType selected - the userType step won't be shown again
      if (props.userType === "") {
        props.handleStateDataChange({
          ["currentStep"]: 2
        });
      }

      props?.setIsShowSaveChanges(false);

      if (!props.isFobSkipped) {
        // // fob supported
        store.dispatch(commonActions.setShowFobScannerInput(true)); // dif 
        store.dispatch(commonActions.setShowScanFobButton(false));
        store.dispatch(commonActions.setShowAssigneFobOptions(false)); // dif 
        store.dispatch(commonActions.setAssigneOption(null)); 
        store.dispatch(commonActions.setShowExsistingParkingAllocation(false));

        // clear fob
        props.handleChange({
          ["fob"] : ""
        });
      }
      else {
        // fob not supported
        store.dispatch(commonActions.setShowFobScannerInput(false));
        store.dispatch(commonActions.setShowScanFobButton(false));
        store.dispatch(commonActions.setShowAssigneFobOptions(true)); // dif 
        store.dispatch(commonActions.setAssigneOption(null)); 

        props.handleChange({
          ["showTemporaryTokenPreview"] : true
        });

        store.dispatch(commonActions.setShowExsistingParkingAllocation(false));
      }
  };

  return (
    <>
    <div className={classes.stepContainer}>
      <div className={classes.stepTitle}>
        {Strings.STEPS_TITLES.ADD_TOKEN_TITLE}
      </div>
      <span className={classes.stepSubTitle}>
        {Strings.STEPS_TITLES.ADD_TOKEN_SUB_TITLE}
      </span>

      {props?.showTemporaryTokenPreview && (
          <ParkerAllocationCard
            fob={props.fob}
            isActive={true}
            name={selectedSite?.displayName}
            image={getSiteIconName(selectedSite.clientId)}
            site={selectedSite}
            handleDeleteAssignedParker={handleDeleteAssignedParker}
            showMenuItems={false}
            showDeleteAction={false}
          />
        )}

      <div className={classes.singleTokenAllocationContainer}>
        <AddSingleTokenParkerAllocation
          {...props}
          setShowSummaryStep={setShowSummaryStep}
          selectedSite={selectedSite}
          handleAssignTokenToFob={handleAssignTokenToFob}
          setShowStepError={setShowStepError} // added
          setIsCurrentStepValid={props.setIsCurrentStepValid} // added
          isFobSkipped={props.isFobSkipped}
          dialingCode={props.dialingCode}
          setIsFobSkipped={props.setIsFobSkipped}
          // ref={AddSingleTokenWithFobRef} // added
          handleClearAllTokens={handleClearAllTokens}
          setIsAddParkingAllocationInProcess={
            props.setIsAddParkingAllocationInProcess
          }
          setIsShowSaveChanges={props.setIsShowSaveChanges}
          occupiedTokens={occupiedTokens}
          totalSteps={props.totalSteps}
          handleChange={handleChange}
        />
        
        {/* <AddSingleTokenAllocation
          {...props}
          setShowSummaryStep={setShowSummaryStep}
          selectedSite={selectedSite}
          handleAssignTokenToFob={handleAssignTokenToFob}
          setShowStepError={setShowStepError} // added
          setIsCurrentStepValid={props.setIsCurrentStepValid} // added
          isFobSkipped={props.isFobSkipped}
          dialingCode={props.dialingCode}
          setIsFobSkipped={props.setIsFobSkipped}
          // ref={AddSingleTokenWithFobRef} // added
          handleClearAllTokens={handleClearAllTokens}
          setIsAddParkingAllocationInProcess={
            props.setIsAddParkingAllocationInProcess
          }
          setIsShowSaveChanges={props.setIsShowSaveChanges}
          occupiedTokens={occupiedTokens}
          totalSteps={props.totalSteps}
          handleChange={handleChange}
        /> */}

        {/* Summary */}
        {showAdditionalParkingAllocationButton && /* props?.assignedParkerAllocations?.length > 0 && */  (
          <div className={classes.summaryAllocationStep}>
            <Divider />
            <span className={classes.stepSubTitle}>
              {Strings.ASSIGNED_PARKING_ALLOCATIONS}
            </span>
            <div className={classes.cardsListContainer}>
              {props?.assignedParkerAllocations?.map((allocation, index) => {
                return (
                  <ParkerAllocationCard
                    //{...props} // fob - props.fob - change to: carUserToken.fob
                    // {...parker}
                    key={index} //{allocation.id}
                    allocation={allocation}
                    fob={allocation?.fob}
                    isActive={allocation?.isActive}
                    //name={`${props?.userData?.utronUser?.firstName} ${props?.userData?.utronUser?.lastName}`}
                    name={allocation?.token?.displayValue}
                    // identify new / existing can be replaced by checking if uuid exists here:
                    image={(allocation?.id === 0 && allocation?.tokenId === 0) /* new token */ || 
                           (allocation?.id === 0 && allocation?.tokenId !== 0) /* existing token */ ? 
                           getSiteIconName(selectedSite?.clientId) : getSiteIconName(allocation?.token?.site?.clientId)}
                    site={selectedSite}
                    uuid={allocation?.uuid}
                    handleDeleteAssignedParker={handleDeleteAssignedParker}
                    handleDeleteCreatedAllocation={handleDeleteCreatedAllocation}
                    openAllocationManagement={props.openAllocationManagement}
                    // showMenuItems={true}
                    // showDeleteAction={false}
                    showMenuItems={allocation?.uuid === undefined}
                    showDeleteAction={allocation?.uuid !== undefined}
                  ></ParkerAllocationCard>
                );
              })}
            </div>
            {/* Additional Button */}
              {showAdditionalParkingAllocationButton && ( 
                <button
                onClick={handleAdditionalParkingAllocation} // scanNewFob
                type="button"
                className={classes.addCarButton}
              >
                <img src={Icons.ALLOCATION2} />
                <span>{Strings.ADDITIONAL_PARKING_ALLOCATION_BUTTON}</span>
              </button>
            )}
            {/* {occupiedTokens.map((token, index) => {
              return (
                <AllocationCard
                  {...props} // fob - props.fob - change to: carUserToken.fob
                  {...token}
                  name={`${props?.selectedParker?.firstName} ${props?.selectedParker?.lastName}`}
                  image={props?.selectedParker.image}
                  showMenuItems={false}
                ></AllocationCard>
              );
            })} */}
          </div>
        )}
      </div>

      {/* check to do the validation in the errorMessage */}
      {
        props.isStepSubmitted && hasStepErrors&&  (
          <div className={classes.error}>This step is required</div>
        )
      }
      </div>
    </>
  );
}); // added ) - for forward ref

export default AssignParkerAllocationStep;
